import axios from "axios";
import { localStorageItem } from './../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { CODE } from "../../utils/Constant";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_PHIEU_LINH = `${API}/slip/formPhieuLinh`;
const API_XUAT_SD = `${API}/slip/formXuatSuDungKhoaPhong`;
const API_BO_SUNG_CO_SO_TU_TRUC = `${API}/slip/themphieubosungcosotutruc`;

// export const searchDSTuTruc = (searchData: any) => {
//   const url = `${API}/category/warehouses?level=2`;
//   return axios.get(url, { params: searchData });
// };

export const getListLoaiPhieuChiDinh = () => {
  const url = `${API}/terms?classId=34`;
  return axios.get(url);
};

export const getListLoaiPhieuTongHop = () => {
  const url = `${API}/terms?classId=35`;
  return axios.get(url);
};

export const getListPhieuChiDinh = (searchData: any) => {
  const url = `${API}/slip/search`;
  return axios.post(url, searchData);
};
export const tongHopPhieuServices = (searchData: any) => {
  const url = `${API}/slip/madication-summary`;
  return axios.post(url, searchData, {
    responseType: 'blob'
  });
};

export const deletePhieuTuTruc = (id: string) => {
  const url = `${API}/slip/${id}`;
  return axios.delete(url);
};

export const getDsVatTuPhieu = (searchData: any) => {
  const url = `${API}/inventory-item/search`;
  return axios.post(url, searchData);
};

export const updateDsVatTuTuTruc = (data: any) => {
  const url = `${API}/inventory-item/update-items`;
  return axios.put(url, data);
};

//Phieu Linh
export const createPhieuLinh = (data: any) => {
  const url = API_PHIEU_LINH;
  return axios.post(url, data);
};

export const updatePhieuLinh = (id: string, data: any) => {
  const url = `${API_PHIEU_LINH}/${id}`;
  return axios.put(url, data);
};

//Xuat su dung khoa/phong

export const createPhieuXuatSD = (data: any) => {
  const url = API_XUAT_SD;
  return axios.post(url, data);
};

export const updatePhieuXuatSD = (id: string, data: any) => {
  const url = `${API_XUAT_SD}/${id}`;
  return axios.put(url, data);
};

// Bổ sung cơ số tủ trực
export const createPhieuBoSungCoSoTuTruc = (data: any) => {
  const url = API_BO_SUNG_CO_SO_TU_TRUC;
  return axios.post(url, data);
};

export const updatePhieuBoSungCoSoTuTruc = (id: string, data: any) => {
  const url = API_BO_SUNG_CO_SO_TU_TRUC + `/${id}`;
  return axios.put(url, data);
};

export const caculatorTonKhoTuTruc = (data: any) => {
  const url = API + `/item/by-id-and-warehouse`;
  return axios.post(url, data);
};

export const printPhieu = (params: any) => {
  const url = `${API}/api/download/cabinet/word/add-base-quantity`;
  return axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const createPhieuHoanTra = (data: any) => {
  const url = API + `/slip/hoanTraThuocDieuTri`;
  return axios.post(url, data);
};

export const updateStatusHoanTra = (id: any) => {
  const url = `${API}/slip/update-status-slip/issue_orders_export/returned_slip/${id}`;
  return axios.put(url);
};

export const getListVisitObject = async () => {
  let url = `${API}/category?classId=51`;

  try {
    const { data } = await axios.get(url);
    if (CODE.SUCCESS === data.code) {
      return data.data.content;
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
